import { render, staticRenderFns } from "./MyPageHeading.vue?vue&type=template&id=110dc167&scoped=true&"
import script from "./MyPageHeading.vue?vue&type=script&lang=js&"
export * from "./MyPageHeading.vue?vue&type=script&lang=js&"
import style0 from "./MyPageHeading.vue?vue&type=style&index=0&id=110dc167&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110dc167",
  null
  
)

export default component.exports